import { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import api from "./axiosSetup";
import "./css/HaesList.css"; // Gleicher Stil wie Häs-Anfragen

const SRVSpareParts = () => {
  const [shownData, setShownData] = useState([]);
  const [hiddenData, setHiddenData] = useState([]);
  const [headers, setHeaders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [activeTab, setActiveTab] = useState("shown");
  const navigate = useNavigate();
  const [isZunftrat, setIsZunftrat] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const fetchSpareParts = async () => {
      try {
        const token = localStorage.getItem("authToken");

        const response = await api.get("/api/my-spareparts", {
          headers: { Authorization: `Bearer ${token}` },
        });

        const responseData = response.data;

        if (responseData.length > 0) {
          const firstItem = responseData[0];
          const dynamicHeaders = [];

          dynamicHeaders.push({ key: "Anfrager", label: "Anfrager" });

          for (const key in firstItem) {
            if (key === "Anfrager" || key === "state") continue;

            const valueObj = firstItem[key];
            if (valueObj && typeof valueObj === "object" && "displayName" in valueObj) {
              dynamicHeaders.push({ key, label: valueObj.displayName });
            } else {
              dynamicHeaders.push({ key, label: key });
            }
          }

          setHeaders(dynamicHeaders);
        }

        // Offene/geschlossene Bestellungen basierend auf state trennen
        const visible = responseData.filter((item) => !item.state || item.state !== "ausgegeben");
        const hidden = responseData.filter((item) => item.state === "ausgegeben");

        setShownData(visible);
        setHiddenData(hidden);
      } catch (err) {
        console.error("Fehler beim Laden der Bestellungen:", err);
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    const checkZunftratStatus = async () => {
      try {
        const token = localStorage.getItem("authToken");
        const res = await api.get("/api/navbar-zunftrat", {
          headers: { Authorization: `Bearer ${token}` },
        });
        setIsZunftrat(res.data.isZunftrat === 1);
      } catch (err) {
        console.error("Fehler beim Abrufen des Zunftrat-Status:", err);
        setIsZunftrat(false);
      }
    };

    fetchSpareParts();
    checkZunftratStatus();
  }, []);

  const handleEdit = (order) => {
    console.log("Meine Bestellung, welche ich bearbeiten möchte: ", order)
    navigate("/service-order-spare-parts", {
      state: { orderId: order.Bestellnummer, from: location.pathname }
    });
  };

  const renderCards = (data) =>
    data.map((order, index) => {
      const getStatusColor = (state) => {
        switch (state) {
          case "ausgegeben":
            return "#28a745"; // grün für erledigt
          case "aufLager":
            return "#3527F5"; // orange für in Bearbeitung
          case "bestellt":
            return "#fd7e14"; // orange für in Bearbeitung
          default:
            return "#dc3545"; // rot für offen
        }
      };
  
      return (
        <div
          key={index}
          className="card mb-4 shadow-sm border-0"
          style={{
            borderRadius: "12px",
            transition: "transform 0.15s",
            backgroundColor: "#fff",
          }}
          onMouseEnter={(e) => (e.currentTarget.style.transform = "scale(1.02)")}
          onMouseLeave={(e) => (e.currentTarget.style.transform = "scale(1)")}
        >
          <div
            className="card-body"
            style={{
              borderLeft: `4px solid ${getStatusColor(order.state)}`,
              padding: "1rem",
            }}
          >
            <div className="d-flex justify-content-between flex-wrap align-items-center mb-3">
              <div style={{ fontSize: "1rem", fontWeight: "500" }}>
                <strong>Anfrager:</strong> {order.Anfrager?.Name || ""}
              </div>
              <div>
                <span
                  style={{
                    backgroundColor: getStatusColor(order.state),
                    color: "#fff",
                    padding: "0.25rem 0.5rem",
                    borderRadius: "8px",
                    fontWeight: "500",
                    fontSize: "0.8rem",
                    textTransform: "capitalize",
                  }}
                >
                  {order.state || "offen"}
                </span>
              </div>
            </div>
  
            <div className="d-flex flex-wrap gap-2">
              {headers
                .filter(({ key }) => key !== "Anfrager" && key !== "state")
                .map(({ key, label }) => {
                  const valueObj = order[key];
                  let content = "";
  
                  if (!valueObj || typeof valueObj !== "object") {
                    content = valueObj ?? "";
                  } else {
                    const value = valueObj?.value ?? "";
                    if (Array.isArray(value)) {
                      content = value.length > 0 ? value.join(", ") : "–";
                    } else {
                      content = String(value);
                    }
                  }
  
                  return (
                    <div
                      key={key}
                      className="px-3 py-2 rounded text-dark"
                      style={{
                        backgroundColor: "#ffe8e6",
                        minWidth: "100px",
                        textAlign: "center",
                        fontSize: "0.9rem",
                        fontWeight: "500",
                      }}
                    >
                      <div style={{ fontSize: "0.75rem", color: "#c0392b" }}>
                        {label}
                      </div>
                      <div>{content}</div>
                    </div>
                  );
                })}
            </div>
  
            {isZunftrat && (
              <div className="text-end mt-3">
                <button
                  className="btn btn-sm btn-outline-danger"
                  onClick={() => handleEdit(order)}
                >
                  Bearbeiten
                </button>
              </div>
            )}
          </div>
        </div>
      );
    });
  
  
  

  if (loading) return <div className="loading">Lädt...</div>;
  if (error) return <div className="error">Fehler: {error}</div>;
  if (shownData.length === 0 && hiddenData.length === 0)
    return (
      <div>
        <h2 className="mb-4 text-center">Ersatzteil-Bestellungen</h2>
        <div className="no-data alert alert-warning">Keine Ersatzteil-Bestellungen vorhanden.</div>
      </div>
    );

  return (
    <div className="container mt-4">
      <h2 className="mb-4 text-center">Ersatzteile-Bestellungen</h2>

      <div className="mb-4 d-flex flex-column flex-md-row gap-2">
        <button
          onClick={() => setActiveTab("shown")}
          className={`btn ${activeTab === "shown" ? "btn-primary" : "btn-outline-primary"}`}
        >
          offene Bestellungen
        </button>
        <button
          onClick={() => setActiveTab("hidden")}
          className={`btn ${activeTab === "hidden" ? "btn-primary" : "btn-outline-primary"}`}
        >
          abgeschlossene Bestellungen
        </button>
      </div>

      {activeTab === "shown" && renderCards(shownData)}
      {activeTab === "hidden" && renderCards(hiddenData)}
    </div>
  );
};

export default SRVSpareParts;
